const baseUrl = process.env.VUE_APP_WEB_API_BASE_URL
const orderPrefix = '/api/order'
const apiNames = {
  // Auth
  CSRF: baseUrl + '/sanctum/csrf-cookie',
  LOGIN: baseUrl + '/login',
  LOGOUT: baseUrl + '/logout',
  MAIL_VERIFY: baseUrl,
  MAIL_VERIFY_RESEND: baseUrl + '/email/verification-notification',
  // User
  USER_REGISTER: baseUrl + '/register',
  USER_PROFILE: baseUrl + orderPrefix + '/user',
  USER_INFO: baseUrl + '/api/user',
  USER_LIST: baseUrl + orderPrefix + '/users',
  USER_AUTHORITY_SETTING: baseUrl + orderPrefix + '/users/authority',
  USER_INVITE: baseUrl + orderPrefix + '/user/invite',
  USER_PRIVATEINFO: baseUrl + orderPrefix + '/user/profile',
  USER_ORGANIZATION: baseUrl + orderPrefix + '/organization',
  USER_FORGOT_PASSWORD: baseUrl + '/forgot-password',
  USER_RESET_PASSWORD: baseUrl + '/reset-password',
  USER_CHANGE_PASSWORD: baseUrl + orderPrefix + '/change-password',
  USER_CHANGE_MAILADDRESS: baseUrl + '/user/profile-information',
  USER_NOTICE_READ: baseUrl + orderPrefix + '/user/notice-read',
  PRODUCT_EXPIRED_DATE_ALERT_READ:
    baseUrl + orderPrefix + '/user/product-expired-date-alert/read',
  PRODUCT_EXPIRED_DATE_ALERT_UNREADS:
    baseUrl + orderPrefix + '/user/product-expired-date-alert-unreads',
  USER_CLOSING_DATE: baseUrl + orderPrefix + '/closing-date',
  USER_LEAVE: baseUrl + orderPrefix + '/user-leave',
  ORGANIZATION_WITHDRAW: baseUrl + orderPrefix + '/organization-withdrew',
  USER_AUTHORITY: baseUrl + orderPrefix + '/users/authority',
  USER_SET_PASSWORD_AFTER_INVITE: baseUrl + '/api/password-reset-after-invite',
  USER_SET_TUTORIAL_STATUS: baseUrl + orderPrefix + '/user/tutorial',
  // Sale
  SALE_REGISTER_EDIT: baseUrl + orderPrefix + '/sale',
  SALE_HISTORY: baseUrl + orderPrefix + '/sales',
  SALE_COMPLETE: baseUrl + orderPrefix + '/sale/complete',
  SALE_COMPLETE_LIST: baseUrl + orderPrefix + '/sales/complete',
  SALE_PAYMENT_LIST: baseUrl + orderPrefix + '/payment',
  SALE_PAYMENT_OPERATION: baseUrl + orderPrefix + '/payment',
  SALE_PAYMENT_OPERATION_LIST: baseUrl + orderPrefix + '/payments',
  SALE_PAYMENT_CANCEL: baseUrl + orderPrefix + '/payment/cancel',
  SALE_RACKNUMBER_BY_PRODUCT:
    baseUrl + orderPrefix + '/ship/racknumber-by-product-ids',
  SALE_COMPLETE_CANCEL: baseUrl + orderPrefix + '/sale/complete/cancel',
  SALE_CANCEL: baseUrl + orderPrefix + '/sale/cancel',
  SALE_DETAIL: baseUrl + orderPrefix + '/sales/detail',
  SALE_NOTE_EDIT: baseUrl + '/api/sale/note',
  SALE_BULK_CANCEL: baseUrl + orderPrefix + '/sale/bulk-cancel',
  SALE_SEND_MAIL_SALES_CSV: baseUrl + orderPrefix + '/sales-csv',
  SALE_ORDER_CONFIRM: baseUrl + orderPrefix + '/sale/confirm',
  SALE_ORDER_CANCEL_CONFIRM: baseUrl + orderPrefix + '/sale/cancel-confirm',
  SALE_SHIPMENT_DELIVERY: baseUrl + orderPrefix + '/sale/shipment-delivery',
  SALE_SHIPMENT_DELIVERY_LIST:
    baseUrl + orderPrefix + '/sale/shipment-delivery',
  // Customer
  CUSTOMERS: baseUrl + orderPrefix + '/customers',
  CUSTOMER_REGISTER_EDIT: baseUrl + orderPrefix + '/customer',
  CUSTOMER_CATEGORY_LIST: baseUrl + orderPrefix + '/customer-categories',
  CUSTOMER_CATEGORY_REGISTER_EDIT: baseUrl + orderPrefix + '/customer-category',
  CUSTOMER_CSV_UPLOAD: baseUrl + orderPrefix + '/customers/upload',
  // Product
  PRODUCT_AND_STOCK_LIST: baseUrl + orderPrefix + '/products/stocks',
  PRODUCT_CATEGORY_LIST: baseUrl + orderPrefix + '/product-categories',
  PRODUCT_LIST: baseUrl + orderPrefix + '/products',
  PRODUCT_REGISTER_EDIT: baseUrl + orderPrefix + '/product',
  PRODUCT_CSV_UPLOAD: baseUrl + orderPrefix + '/products/upload',
  // Maker
  MAKER_LIST: baseUrl + orderPrefix + '/makers',
  MAKER_REGISTER_EDIT: baseUrl + orderPrefix + '/maker',
  // Supplier
  SUPPLIER_LIST: baseUrl + orderPrefix + '/suppliers',
  SUPPLIER_REGISTER_EDIT: baseUrl + orderPrefix + '/supplier',
  SUPPLIER_CSV_UPLOAD: baseUrl + orderPrefix + '/suppliers/upload',
  // ReceivingLocation
  SUGGESTED_RECEIVING_LOCATION_LIST:
    baseUrl + orderPrefix + '/suggested-receiving-locations',
  SUGGESTED_RECEIVING_LOCATION_REGISTER_EDIT:
    baseUrl + orderPrefix + '/suggested-receiving-location',
  SUGGESTED_RECEIVING_LOCATION_DELETE:
    baseUrl + orderPrefix + '/suggested-receiving-location/delete',
  // Order
  ORDER_LIST: baseUrl + orderPrefix + '/orders',
  ORDER_INCOMPLETE_LIST: baseUrl + orderPrefix + '/sale/notifications',
  ORDER_DETAIL_LIST: baseUrl + orderPrefix + '/orders/detail',
  ORDER_REGISTER_EDIT: baseUrl + orderPrefix + '/order',
  ORDER_COMPLETE: baseUrl + orderPrefix + '/complete',
  ORDER_INCOMPLETE: baseUrl + orderPrefix + '/sale/notification/send',
  SALE_DELETE_INCOMPLETE_NOTIFICATION: baseUrl + orderPrefix + '/sale',
  ORDER_COMPLETE_LIST: baseUrl + orderPrefix + '/orders/complete',
  ORDER_PAYMENT_LIST: baseUrl + orderPrefix + '/order-payment',
  ORDER_PAYMENT_OPERATION: baseUrl + orderPrefix + '/order-payment',
  ORDER_PAYMENT_OPERATION_LIST: baseUrl + orderPrefix + '/order-payments',
  ORDER_PAYMENT_CANCEL: baseUrl + orderPrefix + '/order-payment/cancel',
  ORDER_COMPLETE_CANCEL: baseUrl + orderPrefix + '/order/complete/cancel',
  ORDER_CANCEL: baseUrl + orderPrefix + '/order/cancel',
  ORDER_NOTE_EDIT: baseUrl + orderPrefix + '/note',
  ORDER_BULK_CANCEL: baseUrl + orderPrefix + '/order/bulk-cancel',
  ORDER_SEND_MAIL_ORDER_CSV: baseUrl + orderPrefix + '/order-csv',
  // ConsumptionTax
  CONSUMPTION_TAX_LIST: baseUrl + orderPrefix + '/consumption-taxes',
  // Currency
  CURRENCY_LIST: baseUrl + orderPrefix + '/currencies',
  // Counrty
  COUNTRY_LIST: baseUrl + orderPrefix + '/countries',
  COUNTRY_CALLING_CODE_LIST: baseUrl + orderPrefix + '/country-calling-codes',
  // Loading
  LOADING_LIST: baseUrl + orderPrefix + '/loadings',
  LOADING_DETAIL_EDIT: baseUrl + orderPrefix + '/loading',
  LOADING_CANCEL: baseUrl + orderPrefix + '/loading/cancel',
  // Storage
  STORAGE_LIST: baseUrl + orderPrefix + '/storages',
  STORAGE_REGISTER_EDIT: baseUrl + orderPrefix + '/storages',
  STORAGE_PRODUCT_STOCK_LIST: baseUrl + orderPrefix + '/products/stock-list',
  // Ship
  SHIP_LIST: baseUrl + orderPrefix + '/ships',
  SHIP_COMPLETE: baseUrl + orderPrefix + '/ship/comp',
  SHIP_COMPLETE_CANCEL: baseUrl + orderPrefix + '/ship/complete/cancel',
  SHIP_DETAIl_EDIT: baseUrl + orderPrefix + '/sale/ship',
  SHIP_FIX: baseUrl + orderPrefix + '/ship',
  SHIP_CANCEL: baseUrl + orderPrefix + '/ship/cancel',
  SHIP_CSV_UPLOAD: baseUrl + orderPrefix + '/upload-shipments',
  // NotePhrase
  NOTE_PHRASE_LIST: baseUrl + orderPrefix + '/note-phrases',
  NOTE_PHRASE_REGISTER_EDIT: baseUrl + orderPrefix + '/note-phrase',
  NOTE_PHRASE_DELETE: baseUrl + orderPrefix + '/note-phrase/delete',
  // PaymentMethod
  PAYMENT_METHOD_LIST: baseUrl + orderPrefix + '/payment-methods',
  PAYMENT_METHOD_REGISTER_EDIT: baseUrl + orderPrefix + '/payment-method',
  // Refund
  REFUND_LIST: baseUrl + orderPrefix + '/refunds',
  REFUND_REGISTER: baseUrl + orderPrefix + '/refund',
  REFUND_REGISTER_CANCEL: baseUrl + orderPrefix + '/refund/cancel',
  // Stock
  STOCK_MOVE_LIST: baseUrl + orderPrefix + '/storage-moves',
  STOCK_MOVE_REASON_LIST: baseUrl + orderPrefix + '/stock-move-reasons',
  STOCK_MOVE_REASON_REGISTER_EDIT: baseUrl + orderPrefix + '/stock-move-reason',
  STOCK_MOVE_REGISTER: baseUrl + orderPrefix + '/storage-move',
  STOCK_MOVE_CANCEL: baseUrl + orderPrefix + '/storage-move/cancel',
  STOCK_MOVE_SHIP_OPERATION: baseUrl + orderPrefix + '/storage-move/ship',
  STOCK_MOVE_ARRIVAL_OPERATION: baseUrl + orderPrefix + '/storage-move/arrival',
  STOCK_ADJUST: baseUrl + orderPrefix + '/stock-adjust',
  STOCK_ADJUST_LIST: baseUrl + orderPrefix + '/stock-adjusts',
  STOCK_ADJUST_CANCEL: baseUrl + orderPrefix + '/stock-adjust/cancel',
  STOCK_ADJUST_REASON_LIST: baseUrl + orderPrefix + '/stock-adjust-reasons',
  STOCK_ADJUST_PRODUCT_LIST_CSV:
    baseUrl + orderPrefix + '/ledger-sheet/stock-adjust/product-list-csv',
  // Brand
  BRAND_LIST: baseUrl + orderPrefix + '/brands',
  // TransferAccount
  TRANSFER_ACCOUNT_LIST: baseUrl + orderPrefix + '/transfer-accounts',
  TRANSFER_ACCOUNT_REGISTER_EDIT: baseUrl + orderPrefix + '/transfer-account',
  TRANSFER_ACCOUNT_DELETE: baseUrl + orderPrefix + '/transfer-account/delete',
  // CombinedBill
  COMBINED_BILL: baseUrl + orderPrefix + '/ledger-sheet/combined-bill',
  COMBINED_BILL_LIST:
    baseUrl + orderPrefix + '/ledger-sheet/combined-bill/index',
  COMBINED_BILL_DOWNLOAD:
    baseUrl + orderPrefix + '/ledger-sheet/combined-bill/download',
  // ExProduct(旧:jdProduct)
  JDPRODUCT_LIST: baseUrl + orderPrefix + '/exproducts',
  JDPRODUCT_REGISTER_EDIT: baseUrl + orderPrefix + '/exproduct',
  JDPRODUCT_BULK_REGISTER: baseUrl + orderPrefix + '/exproducts/upload',
  // OftenUse
  OFTEN_USE_LIST: baseUrl + orderPrefix + '/often-uses',
  OFTEN_USE_EDIT: baseUrl + orderPrefix + '/often-uses',
  OFTEN_USE_SCREEN: baseUrl + orderPrefix + '/often-use-screens',
  // FileUpload
  FILE_UPLOAD: baseUrl + orderPrefix + '/file-upload',
  // NOTICE
  NOTICE_LIST: baseUrl + orderPrefix + '/external-admin/notices',
  // BalanceOfPayment
  BALANCE_OF_PAYMENT_LIST: baseUrl + orderPrefix + '/balance-of-payments',
  // AggregateData(KPI)
  AGGREGATE_DATA: baseUrl + orderPrefix + '/aggregate-data',
  AGGREGATE_DATA_CSV: baseUrl + orderPrefix + '/aggregate-data/download-csv',
  ETERNAL_SYSTEM_CSV_UPLOAD: baseUrl + orderPrefix + '/external-system/upload',
  ETERNAL_SYSTEM_CSV_UPLOADED:
    baseUrl + orderPrefix + '/external-system/uploaded',
  ETERNAL_SYSTEM_CSV_SALE: baseUrl + orderPrefix + '/external-system/sale',
  ETERNAL_SYSTEM_SEND: baseUrl + orderPrefix + '/external-system/send',
  // FxRate
  FX_RATE_COMBINATION_LIST: baseUrl + orderPrefix + '/fx-rate-combinations',
  // Shop
  SHOP_LIST: baseUrl + orderPrefix + '/shops',
  SHOP_REGISTER_EDIT: baseUrl + orderPrefix + '/shop',
  // Inquiry
  INQUIRY: baseUrl + orderPrefix + '/inquiry',
  // platform
  PLATFORM_LIST: baseUrl + orderPrefix + '/platforms',
  PLATFORM_REGISTER_EDIT: baseUrl + orderPrefix + '/platform',
  // Nextengine
  COOPERATE_NEXTENGINE: baseUrl + orderPrefix + '/nextengine/first-cooperation',
  EC_GOODS_LIST: baseUrl + orderPrefix + '/nextengine/ec-goods-list',
  EC_GOODS_LINK: baseUrl + orderPrefix + '/nextengine/ec-goods-link',
  EC_GOODS_CSV_DOWNLOAD:
    baseUrl + orderPrefix + '/nextengine/ec-goods-csv-download',
  EC_GOODS_CSV_UPLOAD: baseUrl + orderPrefix + '/nextengine/ec-goods-link-bulk',
  EC_RECEIVEORDER_LIST: baseUrl + orderPrefix + '/nextengine/ec-receiveorder/list',
  EC_RECEIVEORDER_REGISTER:
    baseUrl + orderPrefix + '/nextengine/ec-receiveorder/register',
  NEXTENGINE_COOPERATE_CONFIG:
    baseUrl + orderPrefix + '/nextengine/ne-cooperate-config',
  NEXTENGINE_COOPERATE_CONFIG_UPDATE:
    baseUrl + orderPrefix + '/nextengine/ne-cooperate-config/update'
}

export default apiNames
